import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import useDataHandler from "src/components/data-handler/hooks/use-data-handler";
import useErrors from "src/hooks/useErrors";
import axiosInstance from "src/utils/axios";

const useGetData = () => {
  const [state, actions] = useDataHandler();
  const { enqueueSnackbar } = useSnackbar();
  const { data } = state;
  const handleError = useErrors();
  
  useEffect(() => {
    actions.loading();
    const fetchData = async () => {
      try {
        const { status, data } = await axiosInstance(
          "/api/admin/healthlevel-settings"
        );
        if (status === 200) {
          const { data: list } = data;
          if (Boolean(list.length)) {
            actions.success(list.map(item => ({ ...item, isNew: false })));
            return;
          }
          actions.success();
        }
      } catch (err) {
        actions.error();
        handleError(err);
      }
    };
    fetchData();
  }, []);

  const handleUpdate = (id) => (e) => {
    const selectedIndex = data.findIndex((item) => item.id === id);
    const selectedItem = data.find((item) => id === item.id);
    const { value, name } = e.target;
    selectedItem[name] = value;
    const prev = [...data];

    const temp = [...prev];
    temp.splice(selectedIndex, 1, selectedItem);
    actions.success(temp);

  };

  const handleDelete = async (id) => {
     const selectedItem = data.find((item) => item.id === id);

  if (selectedItem?.isNew) {
    const updatedList = data.filter((item) => item.id !== id);
    actions.success(updatedList);
    return;
  }
  try {
    const { status, data: resData } = await axiosInstance.post(
      `/api/admin/healthlevel-settings/${id}`
    );

    if (status === 200) {
      enqueueSnackbar(resData.message || "Deleted successfully");

      const updatedList = data.filter((item) => item.id !== id);
      actions.success(updatedList);
    }
  } catch (err) {
    handleError(err);
  }
};


  const onSubmit = async () => {
    const reqData = new FormData();
    const datass = JSON.stringify(data);
    reqData.append("data", datass);
    try {
      const { status, data } = await axiosInstance.post(
        `/api/admin/healthlevel-settings`,
        reqData
      );
      if (status === 200) {
        enqueueSnackbar(data.message);
      }
    } catch (err) {
      handleError(err);
    }
  };

  return { state, handleUpdate,handleDelete, onSubmit, setData: actions.success };
};
export default useGetData;
